import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59dd2430"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59dd2430')) {
      api.createRecord('59dd2430', component.options)
    } else {
      api.reload('59dd2430', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=59dd2430", function () {
      api.rerender('59dd2430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/manualManage/index.vue"
export default component.exports